import { createFileRoute, redirect } from "@tanstack/react-router";

/** Ticket WK29: Die Meldung steht jetzt direkt über der Gemeindeliste. */
export const Route = createFileRoute("/_cockpit/cockpit/wahlkalender_/aenderung-melden")({
  beforeLoad: () => {
    throw redirect({ to: "/cockpit/wahlkalender" });
  },
});
